import Cookies from "js-cookie";
import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const userCookie = Cookies.get("user");
  const user = userCookie ? JSON.parse(userCookie) : null;
  return (
    // <>{user?.access_token ? children : <Navigate to="/login" replace />}</>
    <>{children}</>
  );
};

export default PrivateRoute;
